import React, { FC, useEffect, useState } from 'react';

import gql from 'graphql-tag';
import { useQuery } from 'react-apollo';

import Select from 'Components-redesign/Select';

import { GetBalance } from './__queries__';

const BALANCE_QUERY = gql`
  query GetBalance {
    adminViewer {
      id

      balanceLegalEntities {
        id
        accountHolders {
          id
          name
        }
        balanceAccounts {
          id
          name
        }
      }
    }
  }
`;

interface Props {
  showLabel?: boolean;
  className?: string;
  onChange?: (value: string) => void;
  onAccountHolderIdChange?: (value: string) => void;
  onBalancecAccountIdChange?: (value: string) => void;
}

const LegalEntitySelector: FC<Props> = ({
  className,
  onChange,
  onAccountHolderIdChange,
  onBalancecAccountIdChange,
}) => {
  const [legalEntityId, setLegalEntityId] = useState<string | null>(null);
  const balanceQuery = useQuery<GetBalance>(BALANCE_QUERY, {
    fetchPolicy: 'cache-and-network',
  });

  const legalEntities = balanceQuery.data?.adminViewer?.balanceLegalEntities || [];

  useEffect(() => {
    if (legalEntityId || !legalEntities.length) {
      return;
    }

    setLegalEntityId(legalEntities[0].id);
  }, [legalEntities, legalEntityId]);

  useEffect(() => {
    if (legalEntityId && onChange) {
      onChange(legalEntityId);
    }
  }, [legalEntityId, onChange]);

  const accountHolderId = legalEntities.find((le) => le.id === legalEntityId)?.accountHolders[0]
    ?.id;
  useEffect(() => {
    if (accountHolderId && onAccountHolderIdChange) {
      onAccountHolderIdChange(accountHolderId);
    }
  }, [accountHolderId, onAccountHolderIdChange]);

  const balanceAccountId = legalEntities.find((le) => le.id === legalEntityId)?.balanceAccounts[0]
    ?.id;
  useEffect(() => {
    if (balanceAccountId && onBalancecAccountIdChange) {
      onBalancecAccountIdChange(balanceAccountId);
    }
  }, [balanceAccountId, onBalancecAccountIdChange]);

  const list: {
    value: string;
    title: string;
  }[] =
    legalEntities.map((le) => ({
      value: le.id,
      title: le.accountHolders[0]?.name,
    })) ?? [];

  if (list.length < 2) {
    return null;
  }

  return (
    <div className={className}>
      <Select
        className="flex-1"
        id="legalentity"
        placeholder="Select legal entity"
        required
        onChange={(e) => {
          // We update the default legal entity in the metadata to remember the last used legal entity
          setLegalEntityId(e.target.value as string);
        }}
        value={legalEntityId}
        options={list}
      />
    </div>
  );
};

export default LegalEntitySelector;
